import ResizeController from '../../assets/js/controllers/resize';

import { mq } from '../../assets/js/helpers';

export default class PreOrder {

	static selector = 'preorder';

	// class variables

	controllers = {
		resize: null
	};

	el = {};

	flags = {
		isMobile: false
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			content: container.querySelectorAll(`.${this.constructor.selector}__product-content`),
			products: container.querySelectorAll(`.${this.constructor.selector}__product`)
		};

		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add / remove event listeners

	#addEventListeners = () => {
		this.controllers.resize = ResizeController.set({
			update: this.#onResizeUpdate,
			render: this.#onResizeRender
		});

		this.matchRowHeights();
	}

	#removeEventListeners = () => {
		ResizeController.clear(this.controllers.resize);
	}

	// listener methods

	#onResizeUpdate = () => {
		if (mq('medium')) {
			if (this.flags.isMobile) {
				this.flags.isMobile = false;
			}
		} else {
			if (!this.flags.isMobile) {
				this.flags.isMobile = true;
			}
		}

		return true;
	}

	#onResizeRender = () => {
		this.matchRowHeights();
	}

	//

	matchRowHeights() {
		this.matchContentHeight();
		this.matchBlurbsHeight();
	}

	matchContentHeight() {
		this.matchRows(this.el.content);
	}

	matchBlurbsHeight() {
		const $product = this.el.products[0];
		const $productBlurbs = $product.querySelectorAll(`.${this.constructor.selector}__product-blurb`);
		const products = [];

		for (let i = 0; i < this.el.products.length; i++) {
			const $curProduct = this.el.products[i];
			products.push({ product: $curProduct, blurbs: $curProduct.querySelectorAll(`.${this.constructor.selector}__product-blurb`) });
		}

		for (let i = 0; i < $productBlurbs.length; i++) {
			const blurbsRow = [];
			for (let k = 0; k < this.el.products.length; k++) {
				const $productBlurb = products[k].blurbs[i];
				blurbsRow.push($productBlurb);
			}
			this.matchRows(blurbsRow);
		}
	}

	matchRows(rows) {
		let maxHeight = 0;
		for (let i = 0; i < rows.length; i++) {
			const $rowInnerWrapper = rows[i].children[0];
			const curHeight = $rowInnerWrapper.offsetHeight;
			maxHeight = Math.max(maxHeight, curHeight);
		}

		for (let i = 0; i < rows.length; i++) {
			const $row = rows[i];
			$row.style.height = `${maxHeight}px`;
		}
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
